import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EndMember from './EndMember'

class ParselEndMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EndMember} {...props}/>
   )
 }
}



export default ParselEndMember;
